import { Environment } from './models/environment.model';

export const environment: Environment = {
  production: false,
  occBaseUrl: 'https://d1-api.ohgar.com',
  mediaBaseUrl: 'https://d1-media.ohgar.com',
  serverRequestOrigin: ' https://d1-www.ohgar.com',
  gtmId: 'GTM-PWMH8K', // For Local Testing
  recaptchaV3: {
    scriptSrc: 'https://www.google.com/recaptcha/api.js',
    siteKey: '6LfughAdAAAAAL5PVqN3b-jEidOFSCBZynVa5adj',
    secretKey: '6LfughAdAAAAAHt753NfMbL2KTVcjx059miLF7to',
    onloadCallbackName: '_google_recaptcha'
  },
  cds: false,
  b2b: false,
  cdc: false,
  cpq: false,
  digitalPayments: false,
  epdVisualization: false,
  oAuthClient: {
    asmClient: {
      clientID: 'ohgar_asm_client'
    },
    trustClient: {
      client_id: 'ohgar',
      client_secret: 'secret',
      grant_type: 'client_credentials'
    },
    generalClient: {
      client_id: 'mobile_android',
      client_secret: 'secret',
      grant_type: 'client_credentials'
    }
  }
};
